import { createClient } from '@supabase/supabase-js'

const URL = process.env.REACT_APP_SUPABASE_URL
const KEY = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(URL, KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'fitprogress-auth',
  }
})

/**
 * Costruisce l'URL di una Edge Function a partire dalla variabile d'ambiente,
 * così l'indirizzo del progetto non è più scritto a mano nei singoli file
 * (cambiare progetto Supabase richiedeva 12 modifiche sparse).
 *   funzioneUrl('send-gift-email') -> https://<progetto>.supabase.co/functions/v1/send-gift-email
 */
export const funzioneUrl = (nome) => `${URL}/functions/v1/${nome}`
